const state = {
    profile: null,
    personalProfile: null,
};

// getters
const getters = {
    getProfile: (state) => {
        return state.profile;
    },
    getPersonalProfile: (state) => {
        return state.personalProfile;
    },
    // Combined getter for easy access to frequently used profile fields
    getCombinedProfile: (state) => {
        if (!state.profile || !state.personalProfile) {
            return null;
        }
        return {
            ...state.profile,
            signature: state.personalProfile.signature,
            profession: state.personalProfile.profession
        };
    },
    getFullName: (state) => {
        if (!state.profile) return '';
        const firstName = state.profile.firstName || '';
        const lastName = state.profile.lastName || '';
        return `${firstName} ${lastName}`.trim();
    }
};

// actions
const actions = {
    setProfile: ({commit}, profile) => {
        commit('setProfile', profile);
    },
    setPersonalProfile: ({commit}, personalProfile) => {
        commit('setPersonalProfile', personalProfile);
    },
    clearProfile: ({commit}) => {
        commit('clearProfile');
    }
};

// mutations
const mutations = {
    setProfile(state, profile) {
        state.profile = profile;
    },
    setPersonalProfile(state, personalProfile) {
        state.personalProfile = personalProfile;
    },
    clearProfile(state) {
        state.profile = null;
        state.personalProfile = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
